import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(e, networkFallback) {
  if (!e?.response || e.code === "ERR_NETWORK" || e.message === "Network Error") {
    return (
      networkFallback ||
      "Não foi possível concluir sua solicitação neste momento. Verifique sua conexão e tente novamente em alguns instantes."
    );
  }
  const detail = e?.response?.data?.detail ?? e?.message;
  if (detail == null) return "Algo deu errado. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const WHATSAPP_NUMBER = "5511917493917";
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  "Olá! Preciso de ajuda com o OFF360/360Taxi."
)}`;
export const CONTACT_EMAIL = "contato@off360.com.br";
